"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getAgentToken = void 0;

var _axios = _interopRequireDefault(require("axios"));

var _jsCookie = _interopRequireDefault(require("js-cookie"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getAgentToken = function getAgentToken(_ref) {
  var url = _ref.url,
      token = _ref.token,
      clientId = _ref.clientId,
      clientSecret = _ref.clientSecret,
      audience = _ref.audience,
      scope = _ref.scope,
      vfTargetStub = _ref.vfTargetStub;
  var headers = {
    'Content-Type': 'application/x-www-form-urlencoded',
    'vf-target-stub': vfTargetStub || false
  };
  var params = {
    grant_type: 'urn:ietf:params:oauth:grant-type:token-exchange',
    subject_token_type: 'urn:ietf:params:oauth:token-type:access_token',
    resource: 'https://apixdev.developer.vodafone.com',
    audience: audience || 'developer',
    scope: scope || 'NAME_OF_API_ALL',
    requested_token_type: 'urn:ietf:params:oauth:token-type:access_token'
  };

  if (token) {
    params.subject_token = token;
  }

  var _JSON$parse = JSON.parse(localStorage.getItem('config')),
      storeToken = _JSON$parse.storeToken;

  var isAuthStoredWithCookies = storeToken == 'cookies';
  if (isAuthStoredWithCookies) headers['X-CSRF-TOKEN'] = _jsCookie.default.get('X-CSRF-TOKEN');
  var data = Object.keys(params).map(function (key) {
    return "".concat(key, "=").concat(encodeURIComponent(params[key]));
  }).join('&');
  return (0, _axios.default)({
    url: "".concat(url),
    auth: {
      username: clientId,
      password: clientSecret
    },
    method: 'POST',
    headers: headers,
    data: data,
    withCredentials: isAuthStoredWithCookies
  }).then(function (res) {
    console.log('res:', res);
    return res.data;
  }).catch(function (error) {
    console.log('error', error);
    throw error.response;
  });
};

exports.getAgentToken = getAgentToken;